import styles from './ChartLayout.module.scss'
import { PropsWithChildrenAndClassName } from 'types/utility.ts'
import classNames from 'classnames'

const ChartLayout = ({ className, ...props }: PropsWithChildrenAndClassName) => {
  return <div {...props} className={classNames(styles.layout, className)} />
}

export default ChartLayout
